import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BeneListService } from '../../../services/beneList.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalRouteService } from '../../../services/modal-route.service';
import { ModalService } from '../../../services/modal.service';
import { CustodianComponent } from '../custodian-component';
@Component({
  selector: 'custodian-component-mmdirect',
  templateUrl: './custodian-component.mmdirect.html',
})
export class CustodianComponentMMDirect extends CustodianComponent {
  constructor(
    beneListService: BeneListService,
    modalRouteService: ModalRouteService,
    router: Router,
    fb: FormBuilder,
    modalService: ModalService
  ) {
    super(beneListService, modalRouteService, router, fb, modalService);
  }
}
